// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"g5-z","colorTextValue":"h5-z","swatches":"i5-z","collapseLink":"j5-z","isCollapsed":"k5-z","dropdown":"l5-z","disabled":"m5-z"};